import AdUnitsIcon from '@mui/icons-material/AdUnits';
import CategoryIcon from '@mui/icons-material/Category';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import Grid from '@mui/material/Grid';

import Button from '@/components/Button';
import GenericDrawer from '@/components/GenericDrawer/index.tsx';
import Modal from '@/components/Modals/Modal';
import { ProductResponse } from '@/providers/HttpProvider/Fulfill/Inventory/types';

import AddProduct from '../dependencies/AddProduct/AddProduct';
import CreateKit from '../dependencies/CreateKit/CreateKit';
import DeactivateProduct from '../dependencies/DeactivateProduct/DeactivateProduct';
import SendToClient from '../dependencies/SendToClient/SendToClient';
import SendToWarehouse from '../dependencies/SendToWarehouse/SendToWarehouse';
import useButtonPanel from './useButtonPanel';

const buttons = [
  'Agregar productos a catálogo',
  'Enviar productos a bodega',
  'Haz un envío a un cliente',
  'Desactivar producto',
  'Crear Kit',
];

const titles = [
  '',
  'Agrega nuevos productos a tu catálogo',
  'Programa ahora tu envío de productos',
  'Haz un envío a un cliente',
  '',
  'Arma un nuevo Kit de productos',
];

const icons = [
  <AdUnitsIcon color="primary" />,
  <WarehouseIcon color="primary" />,
  <Inventory2Icon color="primary" />,
  <></>,
  <CategoryIcon color="primary" />,
];

interface ButtonPanelProps {
  products: ProductResponse['products'];
  onProductsUpdated?: () => Promise<void>;
}

const ButtonPanel = ({ products, onProductsUpdated }: ButtonPanelProps) => {
  const hook = useButtonPanel({ onProductsUpdated });
  return (
    <>
      <Grid
        container
        columnGap={1}
        rowGap={1}
        justifyContent="center"
        sx={{ flexWrap: { xxs: 'wrap', xs: 'nowrap' } }}
      >
        {buttons.map((button, index) => (
          <Grid
            alignItems="center"
            justifyContent="center"
            size={{ xxs: 12, xs: 2.4 }}
            key={button}
          >
            <Button
              size="small"
              sx={{ width: '100%', height: '100%', padding: '0.6rem 0.6rem', fontSize: '0.95rem' }}
              variant="contained"
              disabled={index > 0 && index < 4 && products.length === 0}
              onClick={() => hook.handleButtonSelected(buttons.indexOf(button) + 1)}
            >
              {button}
            </Button>
          </Grid>
        ))}
      </Grid>
      <GenericDrawer
        open={(hook.buttonSelected > 0 && hook.buttonSelected < 4) || hook.buttonSelected === 5}
        onClose={() => hook.handleButtonSelected(0)}
        title={titles[hook.buttonSelected]}
        disableEscapeKeyDown={true}
        iconTitle={icons[hook.buttonSelected - 1]}
      >
        {hook.buttonSelected === 1 && (
          <AddProduct
            onClose={() => hook.handleButtonSelected(0)}
            onProductsAdded={onProductsUpdated}
          />
        )}
        {hook.buttonSelected === 2 && (
          <SendToWarehouse products={products} onClose={() => hook.handleButtonSelected(0)} />
        )}
        {hook.buttonSelected === 3 && (
          <SendToClient products={products} onClose={() => hook.handleButtonSelected(0)} />
        )}
        {hook.buttonSelected === 5 && (
          <CreateKit
            onClose={() => hook.handleButtonSelected(0)}
            onProductsAdded={onProductsUpdated}
          />
        )}
      </GenericDrawer>
      <Modal
        isOpen={hook.buttonSelected === 4}
        onClose={() => !hook.isProcessing && hook.handleButtonSelected(0)}
        title="Desactivar producto"
        onTransitionExited={hook.handleModalExited}
        actions={
          <Grid
            container
            sx={{
              display: 'flex',
              justifyContent: 'space-around',
              width: '100%',
              paddingBottom: '1rem',
              gap: '0.5rem',
            }}
          >
            <Button
              variant="outlined"
              onClick={() => hook.handleButtonSelected(0)}
              disabled={hook.isProcessing}
            >
              Cancelar
            </Button>
            <Button onClick={() => hook.deactivateProducts(products)} disabled={hook.isProcessing}>
              Desactivar producto
            </Button>
          </Grid>
        }
      >
        <DeactivateProduct />
      </Modal>
    </>
  );
};

export default ButtonPanel;
